import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Button, InputNumber, Radio, Form, Modal, Select } from 'antd'
import { Queries, Mutations } from '../../../../graphql'
import Container from '../../../../components/user/Container'
import { datasetsPayment, tabProfile, inputTax } from '../../../../config/datasetsEmployeeRegistration'
import { numberWithCommas } from '../../../../utils/number'
import FormInputTax from '../../../../components/user/FormInputTax'
import { convertToHTMl } from '../../../../utils/markDown'
import { checkTypeInputButton } from '../../../../utils/formInput'
import { changeFormatdate } from '../../../../utils/formatdate'
import moment from 'moment'

const { TabPane } = Tabs
const { Option } = Select;
const { Text, Title } = Typography

class Tax extends Component {
	state = {
		detailProfile : [],
		dataNewProfile : {},
		loaddingDataNews : false,
		dataTabOne: null,
		swiptBox: 'detail',
		templateForm: [],
		formTaxDraft: null,
		conditions:{},
		guideLineTax:{},
		modalGuideLineTax: false,
		dropdownListRelation: [],
		dropdownListTitleMale: []
	}

	fetchProfile = async () =>{
		const { client, location } = this.props

		try{

			let fetchDetailTaxAll = await client.query({
				query: Queries.fetchDetailTaxAll,
				variables: {
					month: parseInt(moment().month())+1,
					year: parseInt(moment().year())
				}
			})
			
			let fetchEmployeeFamily = await client.query({
				query: Queries.fetchEmployeeFamily,
			})
			

			let dataNewsFormTaxDraft = []
			await Object.keys(fetchDetailTaxAll.data).map((keysProfile)=>{
				if(fetchDetailTaxAll.data[keysProfile]){
					if(Array.isArray(fetchDetailTaxAll.data[keysProfile])){
						fetchDetailTaxAll.data[keysProfile].map((valuesArray, keysArray) =>{
							dataNewsFormTaxDraft[keysProfile] = [keysArray]
						})
						fetchDetailTaxAll.data[keysProfile].map((valuesArray, keysArray) =>{
							dataNewsFormTaxDraft[keysProfile][keysArray] = valuesArray
						})
					}else{
						Object.keys(fetchDetailTaxAll.data[keysProfile]).map((keysObject)=>{
							dataNewsFormTaxDraft[keysProfile] =	[keysObject]
							dataNewsFormTaxDraft[keysProfile][keysObject] = fetchDetailTaxAll.data[keysProfile][keysObject];
						})
	
						Object.keys(fetchDetailTaxAll.data[keysProfile]).map((keysObject)=>{
							dataNewsFormTaxDraft[keysProfile][keysObject] = fetchDetailTaxAll.data[keysProfile][keysObject];
						})
					}
				}else{
					 dataNewsFormTaxDraft[keysProfile] = fetchDetailTaxAll.data[keysProfile];
				}
				
			})

			dataNewsFormTaxDraft['fetchEmployeeTax']['isTwoBenefits'] =  dataNewsFormTaxDraft['fetchEmployeeTax']['isTwoBenefits'] ? 1 : 0 

			if(fetchEmployeeFamily.data.fetchEmployeeFamily.length !== 0){
				fetchEmployeeFamily.data.fetchEmployeeFamily.map((values,keys)=>{
					if(values.relationshipText == 'บิดา'){
						dataNewsFormTaxDraft['fetchEmployeeFamilyTax']['fatherStatus'] = values.personStatus
					}else if(values.relationshipText == 'มารดา'){
						dataNewsFormTaxDraft['fetchEmployeeFamilyTax']['motherStatus'] = values.personStatus
					}
				})
			}

			let dataMergegArray = []

			// console.log("123123", dataNewsFormTaxDraft['fetchTaxDraft'])

			if(dataNewsFormTaxDraft['fetchTaxDraft']){
				await Object.keys(dataNewsFormTaxDraft).map((keysProfile)=>{
					if(dataNewsFormTaxDraft[keysProfile]){
						if(keysProfile !== 'detailTax' && keysProfile !== 'fetchEmployeeSocialSecurity'){
							Object.keys(dataNewsFormTaxDraft[keysProfile]).map((keysArray)=>{
								if(keysArray !== '0' && keysArray !== '__typename'){
									dataMergegArray[keysArray] = dataNewsFormTaxDraft[keysProfile][keysArray]
								}
							})
						}
					}
				})
			}else{
				dataNewsFormTaxDraft['fetchTaxDraft'] = []
			}

			if(dataNewsFormTaxDraft['fetchTaxDraft']){
				Object.keys(dataNewsFormTaxDraft['fetchTaxDraft']).map((keysArray)=>{
					if(dataMergegArray[keysArray]){
						if(keysArray !== '0' && keysArray !== '__typename'){

							dataMergegArray[keysArray] = dataNewsFormTaxDraft['fetchTaxDraft'][keysArray]
						}
					}
					
				})
			}

			let formTaxDraftNewsArray = []


			await Object.keys(dataNewsFormTaxDraft).map((keysProfile)=>{
				if(dataNewsFormTaxDraft[keysProfile]){
					Object.keys(dataNewsFormTaxDraft[keysProfile]).map((keysArray)=>{
					if(keysArray !== '0' && keysArray !== '__typename'){
							formTaxDraftNewsArray[keysArray] = dataNewsFormTaxDraft[keysProfile][keysArray]
						}
					})
				}
			})

			if(dataNewsFormTaxDraft['fetchTaxDraft'].length !== 0){
				await Object.keys(formTaxDraftNewsArray).map((keysProfile)=>{
					if(dataMergegArray[keysProfile] || dataMergegArray[keysProfile] == 0){
						formTaxDraftNewsArray[keysProfile] = dataMergegArray[keysProfile]
					}
				})
			}
			
			formTaxDraftNewsArray['accumulateSocial'] = 0

			await this.setState({
				dataTabOne: dataNewsFormTaxDraft,
				formTaxDraft: formTaxDraftNewsArray
			})

		} catch (error) {
			// const errorMessage = error.graphQLErrors[0].message
			// message.error("Token is expired.")
		}
	}

	guideLineTax = async () =>{
		const { client, location } = this.props

		const { data, errors } = await client.query({
            query: Queries.guideLineTax,
		})
		
		this.setState({
			guideLineTax:data.guideLineTax
		})
	}

	modalGuideLineTax = () =>{
		this.setState({
			modalGuideLineTax:true
		})
	}
	
	templateFormTax = async () =>{
		const { client, location } = this.props
		const { formTaxDraft } = this.state

		try{

			const { data, errors } = await client.query({
				query: Queries.templateFormTax,
			})

			const conditions = [];
			await data.templateFormTax.map((value, keys) =>{
				value.showDataForm = true
				if(value.keyName == 'disabled'){
					value.showDataForm = false
				}

				if(formTaxDraft['isSponserDisabled'] == '1'){
					if(formTaxDraft['isNumberOfDisabled'] >= value.keyForm){
						value.showDataForm = true
					}
				}
				conditions[keys] = value
			})

			this.setState({
				// templateForm:data.templateFormTax,
				templateForm:conditions,
				conditions
			})


		} catch (error) {
			// const errorMessage = error.graphQLErrors[0].message
			// console.log('sss')
			// message.error("Token is expired.")
		}
	}

	inputForm = (title, values, offset, col) =>{
		const { dataTabOne, dropdownListRelation } = this.state
		if(values == "" || values == " "){
			if(values !== 0){
				values = null
			}
		}

		return(
			<>
				{
					<Col xs={24} sm={col} className="mb-3">
						<div className="">
							{
								title &&
								<>
									<Text>
										{ title == 'donationCharityNote' ? dataTabOne['detailTax']['donationCharityNote'] : title }
									</Text><br></br>
								</>
							}
							{
								title == 'ความสัมพันธ์' &&
									<>
										<Select  style={{ width: "100%" }}  disabled="true" defaultValue={values}>
											{
												dropdownListRelation.map((value, keys)=>
													<Option value={ value.id }>{ value.label } </Option>
												)
											}
										</Select>
									</>
								||
								<Input 
									defaultValue={ values || values == 0 ? values : 'ไม่พบข้อมูล' } 
									className={  values || values == 0 ? values : 'font-italic' } 
									disabled={true}
								/>
							}
						</div>
					</Col>
				}
			</>
		)
	}

	checkValueInput = (valueInput) =>{
		if(typeof valueInput == 'number'){
			return valueInput
		}else if(valueInput == true){
			return 2
		}else if(valueInput == false){
			return 1
		}else{
			return valueInput
		}
	}

	checkKeyMapdata = (keyMapData, values) =>{
		let newsData = '';
		if(keyMapData== 'isTwoBenefits'){
			newsData = this.checkValueInput(values)
		}else if(values == 0){
			newsData = this.checkValueInput(values)
		}else{
			newsData = this.checkValueInput(values-1)
		}

		return newsData;
	}

	checkKeyMap =  (dataInput, inputKeyMapArray, ketForm, dataType) =>{
		const { dataTabOne, dropdownListRelation } = this.state
		let newsData = '';
		let checkKeyListRelation = '';
		if(dataTabOne[inputKeyMapArray]){
			if(inputKeyMapArray){
				newsData = dataTabOne[inputKeyMapArray][dataInput.keyMapdata[0]];
				if(dataType == 'listDropDrownRealtion'){
					checkKeyListRelation = dropdownListRelation.filter(valueList => valueList.id ==  dataTabOne[inputKeyMapArray][dataInput.keyMapdata[0]]);
					if(checkKeyListRelation.length !== 0){
						newsData = checkKeyListRelation[0].label
					}
				}else if(dataInput.checkValue.length !== 0){
					newsData = dataInput.checkValue[this.checkKeyMapdata(dataInput.keyMapdata[0],dataTabOne[inputKeyMapArray][dataInput.keyMapdata[0]])]
				}else if(typeof newsData === 'number' || dataType == 'money'){
					newsData = newsData ? newsData : 0
				}
			}else if(dataInput.keyMapdata.length !== 1){
				dataInput.keyMapdata.map((value, keys)=>{
					if(dataTabOne[value]){
						newsData += dataTabOne[value]+' ';
					}else{
						newsData = '';
					}
				})
			}else{
					newsData = dataTabOne[inputKeyMapArray][dataInput.keyMapdata[0]];
					if(dataType == 'listDropDrownRealtion'){
						checkKeyListRelation = dropdownListRelation.filter(valueList => valueList.id ==  dataTabOne[inputKeyMapArray][dataInput.keyMapdata[0]]);
						if(checkKeyListRelation.length !== 0){
							newsData = checkKeyListRelation[0].label
						}
					}else if(dataInput.checkValue.length !== 0){
						newsData = dataInput.checkValue[this.checkKeyMapdata(dataInput.keyMapdata[0],dataTabOne[inputKeyMapArray][dataInput.keyMapdata[0]])]
					}else if(typeof newsData === 'number'  || dataType == 'money'){
						newsData = newsData ? newsData : 0
					}
			}
			
			return newsData;
		}else{
			if(dataType == 'money'){
				return 0
			}
		}
	}

	tabsOne = () =>{
		const { dataTabOne, formTaxDraft, modalGuideLineTax, guideLineTax } = this.state
		return (
			<TabPane tab={'ค่าลดหย่อนภาษี'} key="1" className="mb-0">
					<Row>
                        <Col md={8} xs={12}  className="mb-3">
                            <Button className="btn-guide-line px-2" style={{ backgroundColor:"red",color:"#fff", cursor:"default" }}>
								ข้อมูลที่แสดงดังกล่าว นำมาจากฐานข้อมูลบุคลากร
                            </Button>
                        </Col>
                        <Col md={16} xs={12}  className="mb-3">
                        <div align="right" className="div-guild-line">
                            <p style={{ display:"inline-block" }} className="mr-3">
                                <span className="mr-1">ปรังปรุงแก้ไขเมื่อ </span>
                                {changeFormatdate(dataTabOne.detailTax.updatedAt)}{moment(dataTabOne.detailTax.updatedAt).format(' | เวลา HH:mm น.')}
                            </p>
                            <Button className="btn-guide-line" onClick={ () => this.modalGuideLineTax() }>
                                คําแนะนําการใช้ฟอร์ม 
                            </Button>

                            <Modal
                                title= {<Title level={3} className="mb-0">คําแนะนําการใช้ฟอร์ม</Title>}
                                style={{ top: 20 }}
                                visible={modalGuideLineTax}
                                footer={[
                                    // <Button key="back" onClick={ () => this.setState({ modalGuideLineTax:false }) }>Return</Button>,
                                ]}
                                onCancel={ () => this.setState({ modalGuideLineTax:false }) }
                            >
                                <Title level={4}>{ guideLineTax.title }</Title>
                                { guideLineTax.description ? <div className="custom-modal-tax" dangerouslySetInnerHTML={{ __html: convertToHTMl(guideLineTax.description) }}/> : '' }
                            </Modal>
                        </div>
                        </Col>
                    </Row>

					<Modal
						title= {<Title level={3} className="mb-0">คําแนะนําการใช้ฟอร์ม</Title>}
						style={{ top: 20 }}
						visible={modalGuideLineTax}
						footer={[
							// <Button key="back" onClick={ () => this.setState({ modalGuideLineTax:false }) }>Return</Button>,
						]}
						onCancel={ () => this.setState({ modalGuideLineTax:false }) }
					>
						<Title level={4}>{ guideLineTax.title }</Title>
						{ guideLineTax.description ? <div className="custom-modal-tax" dangerouslySetInnerHTML={{ __html: convertToHTMl(guideLineTax.description) }}/> : '' }
					</Modal>
				<Row gutter={16} type="flex" justify="space-between" align="bottom">
					{
						dataTabOne &&(
							<>
								{
									inputTax.tax_1.form.map((value, keys) =>{
										return <>
												{
													value['borderTop'] &&
													<Col xs={24} md={24} className="mb-2">
														<hr></hr>
													</Col>
												}
												{
													typeof value.ketForm == 'number' && 
														<>
															{
																(
																	dataTabOne.detailTax.isSponserDisabled == 1  && 
																	value.ketForm <= dataTabOne.detailTax.isNumberOfDisabled 
																) &&
																	<>
																		<Col xs={24} md={24} className="mb-2">
																			<strong className="color-red">
																				{ value.title }
																			</strong>
																		</Col>
																		{
																			value.checkArray &&
																			value['formValue'].map((valueInput, keys) =>{
																				return <>
																					{
																						valueInput.typeData === 'money' &&
																							this.inputForm( 
																								valueInput.label ,
																								dataTabOne ? numberWithCommas(this.checkKeyMap(valueInput,value.checkArray, false, 'money').toFixed(2).toString()) : '', 
																								valueInput.offset, 
																								valueInput.col
																							) 
																						|| 
																						valueInput.typeData === 'date' &&
																							this.inputForm( 
																								valueInput.label , 
																								dataTabOne ? this.checkKeyMap(valueInput,value.checkArray, value.ketForm, valueInput.typeData) : '', 
																								valueInput.offset, 
																								valueInput.col
																							) 
																						||
																						<>
																							{ this.inputForm( 
																									valueInput.label , 
																									dataTabOne ? this.checkKeyMap(valueInput,value.checkArray, value.ketForm, valueInput.typeData) : '', 
																									valueInput.offset, 
																									valueInput.col
																								)  
																							}
																						</>
																						
																					}
																				</>
																			})
																		}
																	</>
															}
														</>
													||
													<>
														{
															value.checkArray &&
															<>
																<Col xs={24} md={24} className="mb-2">
																	<strong className="color-red">
																		{ value.title }
																	</strong>
																</Col>
																{
																		value['formValue'].map((valueInput, keys) =>{
																			return <>
																				{
																					valueInput.typeData === 'money' &&
																						this.inputForm( 
																							valueInput.label , 
																							dataTabOne ? numberWithCommas(this.checkKeyMap(valueInput,value.checkArray, value.ketForm, 'money').toFixed(2).toString()) : '',
																							valueInput.offset,
																							 valueInput.col
																						) 
																					|| 
																					valueInput.typeData === 'date' &&
																						this.inputForm( 
																							valueInput.label , 
																							dataTabOne ? this.checkKeyMap(valueInput,value.checkArray, value.ketForm, valueInput.typeData) : '', 
																							valueInput.offset, 
																							valueInput.col
																						) 
																					||
																					<>
																						{ this.inputForm( 
																								valueInput.label ,
																								dataTabOne ? this.checkKeyMap(valueInput,value.checkArray, value.ketForm, valueInput.typeData) : '', 
																								valueInput.offset, 
																								valueInput.col
																							)  
																						}
																					</>
																					
																				}
																			</>
																		})
																}
															</>
														}
														{
															value['borderShow'] &&
															<Col xs={24} md={24} className="mb-2">
																<hr></hr>
															</Col>
														}
													</>
												}
											</>
									})
								}
							</>
						)
						||
						<>
							{
								inputTax.tax_1.form.map((value, keys) =>{
									return <>
											<Col xs={24} md={24} className="mb-2">
												<strong className="color-red">
													{ value.title }
												</strong>
											</Col>
											{
												value['formValue'].map((valueInput, keys) =>{
													this.inputForm( valueInput.label , '', valueInput.offset, valueInput.col) 
												})
											}
											<Col xs={24} md={24} className="mb-2">
												<hr></hr>
											</Col>
										</>
								})
							}
						</>
					}
				</Row>
				<Row gutter={16} type="flex" justify="space-between" align="top" className="mt-4">
					<Col span={24}>
						{
							formTaxDraft['updatedAt'] &&
							<p className="mb-0">บันทึกร่างเมื่อ {changeFormatdate(formTaxDraft['updatedAt'])}{moment(formTaxDraft['updatedAt']).format(' | เวลา HH:mm น.')}</p>
						}
					</Col>
				</Row>
			</TabPane>
		)
	}

	tabsForm = () =>{
		const { dataTabOne, templateForm, formTaxDraft, conditions, dropdownListRelation, dropdownListTitleMale, dropdownListTitleFemale, guideLineTax } = this.state
		// console.log('formTaxDraft',formTaxDraft)
		// console.log('templateForm',templateForm)
		return (
			<TabPane tab={'ค่าลดหย่อนภาษี'} key="1" className="mb-0">
				<FormInputTax 
					templateForm={templateForm} 
					formTaxDraft={formTaxDraft} 
					conditions={conditions}
					handleSubmitDarf={this.handleSubmitDarf}
					handleSubmitSead={this.handleSubmitSead}
					dropdownListRelation={dropdownListRelation}
					dropdownListTitleMale= {dropdownListTitleMale}
					dropdownListTitleFemale = {dropdownListTitleFemale}
					dataTabOne= {dataTabOne}
					guideLineTax= {guideLineTax}
				/>
			</TabPane>
		)
	}

	checkTypeInputButton = (values) =>{
		Object.keys(values).map((keysData)=>{
			if(checkTypeInputButton(keysData,values[keysData]) || checkTypeInputButton(keysData,values[keysData]) == '0'){
				values[keysData] = checkTypeInputButton(keysData,values[keysData])
			}
		})

		return values
	}

	handleSubmitDarf = async (values) => {
		const { dataTabOne, formTaxDraft }  = this.state
		values = this.checkTypeInputButton(values)
		try {
			const { client } = this.props
			if(dataTabOne['fetchTaxDraft'].length !== 0){
				const { data, errors } = await client.mutate({
					mutation: Mutations.updateTaxDraft,
					variables: {
						...values,
						taxDraftId: formTaxDraft['taxDraftId'],
						isDelete: 0
					}
				})

				if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
					await this.setState({
						showModalErrors: true
					})
				}
				window.scrollTo(0, 0);
				message.success('บันทึกฉบับร่างเรียบร้อย');
			}else{
				const { data, errors } = await client.mutate({
					mutation: Mutations.createTaxDraft,
					variables: {
						...values,
						isDelete: 0
					}
				})

				if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
					await this.setState({
						showModalErrors: true
					})
				}
				window.scrollTo(0, 0);
				message.success('บันทึกฉบับร่างเรียบร้อย');
			}
			
			await this.fetchProfile()
			await this.setState({
				swiptBox: 'detail'
			})
		} catch (error) {
			
		}
	}

	handleSubmitSead = async (values) => {
		const { dataTabOne, formTaxDraft }  = this.state
		values = this.checkTypeInputButton(values)

		try {
			const { client } = this.props
			if(dataTabOne['fetchTaxDraft'].length !== 0){
				const { data, errors } = await client.mutate({
					mutation: Mutations.updateTaxDraft,
					variables: {
						...values,
						taxDraftId: formTaxDraft['taxDraftId'],
						isDelete: 1
					}
				})

				if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
					await this.setState({
						showModalErrors: true
					})
				}
				window.scrollTo(0, 0);
				message.success('ทำการส่งเรียบร้อย');
			}else{
				const { data, errors } = await client.mutate({
					mutation: Mutations.createTaxDraft,
					variables: {
						...values,
						isDelete: 1
					}
				})

				if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
					await this.setState({
						showModalErrors: true
					})
				}

				window.scrollTo(0, 0);
				message.success('ทำการส่งเรียบร้อย');
			}
			
			await this.fetchProfile()
			await this.setState({
				swiptBox: 'detail'
			})
		} catch (error) {
			// console.log('error',error)
			// message.error("รหัสบุคลากรไม่ถูกต้อง")
			// const errorMessage = error.graphQLErrors[0].message
			// message.error(ErrorMessageFormAPI(errorMessage))
		}
	}

	swiptBoxShow = (data) =>{
		window.scrollTo(0, 0);
		this.setState({
			swiptBox: data
		})
	}

	dropdownListRelation = async() =>{
		const { client, location } = this.props
		try{
			const { data, errors } = await client.query({
				query: Queries.dropdownListRelation,
			})

			await this.setState({
				dropdownListRelation: data.dropdownListRelation
			})


		} catch (error) {
			// const errorMessage = error.graphQLErrors[0].message
			// console.log('sss')
			// message.error("Token is expired.")
		}
	}

	dropdownListTitleMale = async()=>{
		const { client, location } = this.props
		try{
			const { data, errors } = await client.query({
				query: Queries.dropdownListTitleMale,
			})
			await this.setState({
				dropdownListTitleMale: data.dropdownListTitleMale
			})


		} catch (error) {
			// const errorMessage = error.graphQLErrors[0].message
			// console.log('sss')
			// message.error("Token is expired.")
		}
	}

	dropdownListTitleFemale = async()=>{
		const { client, location } = this.props
		try{
			const { data, errors } = await client.query({
				query: Queries.dropdownListTitleFemale,
			})

			await this.setState({
				dropdownListTitleFemale: data.dropdownListTitleFemale
			})


		} catch (error) {
			// const errorMessage = error.graphQLErrors[0].message
			// console.log('sss')
			// message.error("Token is expired.")
		}
	}

	async componentDidMount(){
		await this.fetchProfile();
		await this.templateFormTax();
		await this.guideLineTax();
		await this.dropdownListRelation();
		await this.dropdownListTitleMale();
		await this.dropdownListTitleFemale();
	}

	render() {
		const { history, location, match, staticContext } = this.props
		const { templateForm, dataTabOne, swiptBox, formTaxDraft, modalGuideLineTax, guideLineTax, dropdownListRelation,dropdownSelectForm} = this.state
		// console.log('dataTabOne',dataTabOne)
        if(swiptBox == 'detail'){
			return (
				<>
					{
						( dataTabOne && dropdownListRelation.length !== 0 ) &&
						<Container match={match}>
							<div className="card-container" id="page-tax">
								<div className="px-5 py-1 card-bg-green" style={{ position:"relative" }}>
									<Tabs type="card" style={{borderBottom:"6px solid #d7222a"}} className="my-4">
										{ this.tabsOne() }
									</Tabs>
								</div>
								<div className="mt-5">
									<Row>
										<Col align="center">
											<Button className="btn-link-page" onClick={ () => this.swiptBoxShow('form') }>
												แก้ไขข้อมูล 
											</Button>
										</Col>
									</Row>
								</div>
							</div>
						</Container>
						||
						<Container match={match}>
							<div className="card-container" id="page-tax">
								<div className="px-5 py-1 card-bg-green">
									<Row>
										<Col align="center" className="mt-5">
											<Spin size="large" />
										</Col>
									</Row>
								</div>
							</div>
						</Container>
					}
				</>
			)
		}else{
			return(
				<>
					{
						templateForm.length !== 0 &&
						<Container match={match}>
							<div className="card-container" id="page-tax">
								<div className="px-5 py-1 card-bg-green">
									<Tabs type="card" style={{borderBottom:"6px solid #d7222a"}} className="my-4">
										{ this.tabsForm() }
									</Tabs>
								</div>
								<div className="mt-5">
									<Row>
										<Col align="center">
											<Button className="btn-link-page" onClick={ () => this.swiptBoxShow('detail') }>
												กลับไปหน้าดูข้อมูล
											</Button>
										</Col>
									</Row>
								</div>
							</div>
						</Container>
					}
				</>
			)
		}
	
	}
}


export default withApollo(Tax)
